import { render, staticRenderFns } from "./hsnp_wizard_step_02_sales_relative.vue?vue&type=template&id=637922b2&scoped=true"
import script from "./hsnp_wizard_step_02_sales_relative.vue?vue&type=script&lang=js"
export * from "./hsnp_wizard_step_02_sales_relative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637922b2",
  null
  
)

export default component.exports